import { createI18n } from 'vue-i18n';

import enUS from './en-US.json';
import idID from './id-ID.json';
import jaJP from './ja-JP.json';
import koKR from './ko-KR.json';

export enum Locales {
  idID = 'id-ID',
  enUS = 'en-US',
  koKR = 'ko-KR',
  jaJP = 'ja-JP',
}

type MessageSchema = typeof enUS;

export const LocalesWithLabel: { [index: string]: string } = {
  [Locales.idID]: 'Bahasa Indonesia',
  [Locales.enUS]: 'English',
  [Locales.koKR]: '한국어',
  [Locales.jaJP]: '日本語',
};

export const i18n = createI18n<[MessageSchema], Locales.idID | Locales.enUS | Locales.koKR | Locales.jaJP, false>({
  allowComposition: true,
  legacy: false,
  messages: {
    [Locales.idID]: idID,
    [Locales.enUS]: enUS,
    [Locales.koKR]: koKR,
    [Locales.jaJP]: jaJP,
  },
  datetimeFormats: {
    [Locales.idID]: {
      short: {
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
    },
    [Locales.enUS]: {
      short: {
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
    },
    [Locales.koKR]: {
      short: {
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
    },
    [Locales.jaJP]: {
      short: {
        month: 'short',
        day: '2-digit',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      },
    },
  },
});
